/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IConceptDataType } from 'app/shared/model/concept-data-type.model';
import { ILabTestCategory } from 'app/shared/model/lab-test-category.model';
import { ICatalogDefinitions } from 'app/shared/model/catalog-definitions.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface ILabTestItem {
  id?: string;
  active?: boolean;
  lastupdated?: number | null;
  measurement?: string | null;
  methodName?: string | null;
  sortOrder?: number;
  testLocalAbbrev?: string | null;
  testName?: string | null;
  timestampentry?: number;
  microSec?: number;
  cursor?: number;
  sample?: string | null;
  dataType?: IConceptDataType | null;
  category?: ILabTestCategory;
  catalog?: ICatalogDefinitions | null;
  testType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<ILabTestItem> = {
  active: false,
};
